import { BusinessObjectBase } from './base';
import type { Candidate } from './candidate';
import type { Position } from './position';

export interface StaffTypeData {
  readonly id: string;
  readonly name?: string;
  readonly description?: string;
  readonly candidates?: Candidate[];
  readonly positions?: Position[];
}

export interface StaffType extends Readonly<StaffTypeData> {}
export class StaffType extends BusinessObjectBase {
  static readonly entityName = 'StaffType' as const;
  static readonly plural = 'staff-types';

  // --- Static CRUD methods ---

  static async find(filter?: any): Promise<StaffType[]> {
    const url = `${this.baseUrl}/${this.plural}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const results = await this.get<any[]>(url, params);
    return results.map((data) => new StaffType(data));
  }

  static async findOne(filter?: any): Promise<StaffType | null> {
    const url = `${this.baseUrl}/${this.plural}/find-one`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return data ? new StaffType(data) : null;
  }

  static async findById(id: string, filter?: any): Promise<StaffType> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return new StaffType(data);
  }

  static async create(data: Omit<StaffTypeData, 'id'>): Promise<StaffType> {
    const url = `${this.baseUrl}/${this.plural}`;
    const result = await this.post<any>(url, data);
    return new StaffType(result);
  }

  static async updateById(
    id: string,
    data: Partial<StaffTypeData>,
  ): Promise<StaffType> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const result = await this.patch<any>(url, data);
    return new StaffType(result);
  }

  static async deleteById(id: string): Promise<boolean> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    try {
      await this.del<void>(url);
      return true;
    } catch {
      return false;
    }
  }
}
